import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../dto/dto.js';
import { TimeOfDay } from './time-of-day.js';

export class TimeSpan extends DataModel {
  static readonly TYPE_ID: string = '77eab58be9d244388c6db33c29684543';

  constructor(
    public readonly from: TimeOfDay,
    public readonly to: TimeOfDay,
  ) {
    super();
  }

  get $typeId() {
    return TimeSpan.TYPE_ID;
  }

  get durationInMinutes(): number {
    return this.to.inMinutes - this.from.inMinutes;
  }

  static fromMap(context: SerializationContext, map: SerializedData): TimeSpan {
    return new TimeSpan(
        context.fromData<TimeOfDay>(MapUtils.getRaw(map, 'from') as SerializedData),
        context.fromData<TimeOfDay>(MapUtils.getRaw(map, 'to') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'from': context.toData(this.from),
      'to': context.toData(this.to),
    };
  }

  clone(): this {
    return new TimeSpan(
        this.from.clone(),
        this.to.clone(),
    ) as this;
  }

  isSame(other: TimeSpan): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.from, this.from) &&
        isSameData(other.to, this.to);
  }
}

export class TimeSpanBuilder extends DataModelBuilder<TimeSpan> {
  build(context: SerializationContext, map: SerializedData): TimeSpan {
    return TimeSpan.fromMap(context, map);
  }
}
